export const PROCESSOS_ZE_PAGE = () => "/processos-ze";
